export default __webpack_public_path__ + "static/phone-cb41c74e3135701d07c6ea97421f60e0.svg";